import type { FaireThemeEntity } from "../../entity_types/theme";

export const clean_beauty_and_vitality: FaireThemeEntity = {
  token: "clean-beauty-and-vitality",
  type: "theme",
  name: "Clean Beauty & Vitality",
  description: "Elevate your pop-up's wellness corner with non-toxic makeup and essential mineral supplements that support inner and outer health.",
  teaser: "This theme aligns with your store's focus on 'natural ingredients,' 'non-toxic,' and 'organic' products, matching your frequent orders of healing salves, body creams, and oral vitamins.",
  detail: "The additional_context supports this theme through your recent engagement with the Ionic Liquid Iodine supplement and the Liquid Mineral Organic Foundation.",
  bgColor: "#D4C4B0",
  tileBgColor: "#6b3838",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_3zruhwc4pc",
    "p_9a2uvmc3hg",
    "p_jdby3x8ez7",
    "p_dgebs00f8d",
    "p_dk45vjlj",
    "p_qgsjkj6h5e",
    "p_mhbj677rz2",
    "p_9c467kaqyh",
    "p_e8b6rxq4x3",
    "p_7b9az77bav",
    "p_u8qmdcdnma",
    "p_wmjp7d9nkb",
    "p_9endjgemtm",
    "p_ess8runjag",
    "p_4v3qdu3299",
    "p_p2ctth6m5y",
    "p_b3k1jvsslk",
    "p_e8cd1ivbfs",
    "p_q5mejd59pc",
    "p_2uzdypad",
    "p_tng7g8d9ha",
    "p_eay9k97q29",
    "p_etm8mhbfnu",
    "p_2tyv2scs4s",
    "p_szfa9eng6w",
    "p_538v57cd0d",
    "p_9n3f4pc7rj",
    "p_v9vh5q5drf",
    "p_qq8scfss8d",
    "p_evqw5jrajk",
    "p_he74a34gbk",
    "p_gw383m8ezq",
    "p_nnk56j8jt5",
    "p_pfj6p27mm5",
    "p_rdwaqstn5c",
    "p_9mo4stxz3d",
    "p_t8u3cmmhga",
    "p_kj35tw5uxh",
    "p_fs72p959vh",
    "p_7prp39jhkv",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
